var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterBox = function SvgTwitterBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    enableBackground: "new 0 0 23 23",
    xmlSpace: "preserve"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#07B1EA",
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19,7.7c-0.3,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.6,0.1-0.8,0.2c0.3-0.2,0.6-0.4,0.8-0.7   c0.2-0.3,0.4-0.6,0.5-0.9c-0.3,0.1-0.6,0.3-0.9,0.4c-0.3,0.1-0.6,0.2-1,0.3c-0.2-0.3-0.5-0.5-0.9-0.7c-0.3-0.2-0.7-0.2-1.2-0.2   c-0.8,0-1.5,0.3-2,0.8s-0.8,1.3-0.8,2.1c0,0.2,0,0.4,0.1,0.6C10.7,9.8,9.6,9.5,8.6,9C7.6,8.4,6.7,7.7,6,6.8C5.7,7.3,5.6,7.8,5.6,8.3   c0,1.1,0.4,1.9,1.3,2.4c-0.5,0-0.9-0.1-1.3-0.3v0c0,0.7,0.2,1.3,0.6,1.8c0.4,0.5,1,0.9,1.6,1c-0.1,0-0.2,0-0.3,0.1   c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.5-0.1c0.2,0.6,0.5,1,1,1.4c0.5,0.4,1,0.6,1.7,0.6c-1,0.8-2.2,1.2-3.6,1.2H5   c0.6,0.4,1.3,0.7,2.1,0.9c0.8,0.2,1.5,0.3,2.3,0.3c1.3,0,2.5-0.2,3.5-0.7c1-0.5,1.9-1.1,2.6-1.9c0.7-0.8,1.2-1.7,1.6-2.6   c0.3-1,0.5-1.9,0.5-2.9V9.2c0.3-0.2,0.6-0.4,0.8-0.7C18.6,8.2,18.8,7.9,19,7.7z",
    style: {
      fill: "#FFFFFF"
    }
  }));
};
export default SvgTwitterBox;